(function () {
  const NOVA_POST_SECTION_ID = 'shopify-section-template--26835354517547__178415448660d028eb';
  const CART_SECTION_ID = 'shopify-section-template--26835354517547__cart-section';
  const SLOT_ID = 'nova-post-slot';

  let widgetRef = null;

  function captureWidget() {
    if (widgetRef) return widgetRef;
    widgetRef = document.getElementById(NOVA_POST_SECTION_ID);
    return widgetRef;
  }

  function relocateNovaPost() {
    const widget = captureWidget();
    const slot = document.getElementById(SLOT_ID);

    if (!widget || !slot) return;
    if (slot.contains(widget)) return;

    slot.appendChild(widget);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', relocateNovaPost);
  } else {
    relocateNovaPost();
  }

  const cartSection = document.getElementById(CART_SECTION_ID);
  if (cartSection) {
    const observer = new MutationObserver(() => {
      relocateNovaPost();
    });
    observer.observe(cartSection, { childList: true, subtree: true });
  }
})();